import NewPreferencesPage from './NewPreferencesPage';

export default NewPreferencesPage;
